/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientBookingDetailApiResponse } from '../models/ClientBookingDetailApiResponse';
import type { ClientCancelBookingApiResponse } from '../models/ClientCancelBookingApiResponse';
import type { ClientCancelBookingDto } from '../models/ClientCancelBookingDto';
import type { ClientRescheduleSessionApiResponse } from '../models/ClientRescheduleSessionApiResponse';
import type { ClientRescheduleSessionDto } from '../models/ClientRescheduleSessionDto';
import type { ClientRespondAttendanceApiResponse } from '../models/ClientRespondAttendanceApiResponse';
import type { ClientRespondAttendanceDto } from '../models/ClientRespondAttendanceDto';
import type { ClientSessionDetailApiResponse } from '../models/ClientSessionDetailApiResponse';
import type { ExpertAvailabilityApiResponse } from '../models/ExpertAvailabilityApiResponse';
import type { FetchClientBookingsApiResponse } from '../models/FetchClientBookingsApiResponse';
import type { FollowupPlanDetailApiResponse } from '../models/FollowupPlanDetailApiResponse';
import type { PendingFollowupPlansApiResponse } from '../models/PendingFollowupPlansApiResponse';
import type { RespondFollowupApiResponse } from '../models/RespondFollowupApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppSessionsService {
    /**
     * List client bookings with session info
     * Returns all bookings for the authenticated client. Filter by status (active/completed/cancelled), type (package/single_session), and optional session scheduled date (UTC day).
     * @param status Filter by booking status
     * @param type Filter by booking type
     * @param dayStartUtc Start of the day range as a full ISO-8601 UTC timestamp. For a local day view, send local midnight converted to UTC.
     * @param dayEndUtc End of the day range (exclusive) as a full ISO-8601 UTC timestamp.
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchClientBookingsApiResponse Bookings fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerFetchClientBookingsV1(
        status?: Array<'pending' | 'active' | 'completed' | 'cancelled' | 'payment_failed' | 'payment_failed_retryable'>,
        type?: 'package' | 'single_session',
        dayStartUtc?: string,
        dayEndUtc?: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<FetchClientBookingsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions',
            query: {
                'status': status,
                'type': type,
                'dayStartUtc': dayStartUtc,
                'dayEndUtc': dayEndUtc,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get booking/package detail
     * Returns full booking detail including package info, all sessions, expert details (including phone country code and phone number), location, cancellation request status, and refund info.
     * @param bookingId Booking UUID
     * @returns ClientBookingDetailApiResponse Booking detail fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerGetBookingDetailV1(
        bookingId: string,
    ): CancelablePromise<ClientBookingDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions/bookings/{bookingId}',
            path: {
                'bookingId': bookingId,
            },
            errors: {
                404: `Booking not found`,
            },
        });
    }
    /**
     * Request package/booking cancellation
     * Client requests cancellation of a booking. Creates a dispute that the JFit team will review. A refund may be issued based on the cancellation policy.
     * @param bookingId Booking UUID
     * @param requestBody
     * @returns ClientCancelBookingApiResponse Cancellation request submitted successfully
     * @throws ApiError
     */
    public static clientSessionsControllerCancelBookingV1(
        bookingId: string,
        requestBody: ClientCancelBookingDto,
    ): CancelablePromise<ClientCancelBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/sessions/bookings/{bookingId}/cancel',
            path: {
                'bookingId': bookingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid booking state for cancellation`,
                404: `Booking not found`,
            },
        });
    }
    /**
     * Get pending followup plan
     * Returns the latest pending followup plan recommended by an expert for the authenticated client.
     * @param sessionId
     * @returns PendingFollowupPlansApiResponse Pending followup plan fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerGetPendingFollowupPlanV1(
        sessionId: string,
    ): CancelablePromise<PendingFollowupPlansApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions/followup-plans/pending/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
        });
    }
    /**
     * Get followup plan detail
     * Returns detail of a specific followup plan including expert rating and service info.
     * @param planId Followup Plan UUID
     * @returns FollowupPlanDetailApiResponse Followup plan detail fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerGetFollowupPlanDetailV1(
        planId: string,
    ): CancelablePromise<FollowupPlanDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions/followup-plans/{planId}',
            path: {
                'planId': planId,
            },
            errors: {
                404: `Followup plan not found`,
            },
        });
    }
    /**
     * Reject a followup plan
     * Client rejects a recommended followup plan from their expert. To accept, book directly via the bookings endpoint.
     * @param planId Followup Plan UUID
     * @returns RespondFollowupApiResponse Followup plan rejected successfully
     * @throws ApiError
     */
    public static clientSessionsControllerRejectFollowupV1(
        planId: string,
    ): CancelablePromise<RespondFollowupApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/sessions/followup-plans/{planId}/reject',
            path: {
                'planId': planId,
            },
            errors: {
                400: `Invalid plan state or expired`,
                404: `Followup plan not found`,
            },
        });
    }
    /**
     * Get session detail
     * Returns full session detail including expert info, booking/package details, location, service, attendance status, and reschedule info.
     * @param sessionId Session UUID
     * @returns ClientSessionDetailApiResponse Session detail fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerGetSessionDetailV1(
        sessionId: string,
    ): CancelablePromise<ClientSessionDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                404: `Session not found`,
            },
        });
    }
    /**
     * Get expert availability for rescheduling
     * Returns the expert's available time slots and blocked dates for the given date range. Used when the client picks a new time during reschedule.
     * @param sessionId Session UUID
     * @param startDate Start date for availability lookup
     * @param endDate End date for availability lookup
     * @returns ExpertAvailabilityApiResponse Availability fetched successfully
     * @throws ApiError
     */
    public static clientSessionsControllerGetExpertAvailabilityV1(
        sessionId: string,
        startDate: string,
        endDate: string,
    ): CancelablePromise<ExpertAvailabilityApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/sessions/{sessionId}/availability',
            path: {
                'sessionId': sessionId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                404: `Session not found`,
            },
        });
    }
    /**
     * Reschedule a session
     * Client selects a new time slot and submits a reschedule request. The session is updated to the new time immediately.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns ClientRescheduleSessionApiResponse Session rescheduled successfully
     * @throws ApiError
     */
    public static clientSessionsControllerRescheduleSessionV1(
        sessionId: string,
        requestBody: ClientRescheduleSessionDto,
    ): CancelablePromise<ClientRescheduleSessionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/sessions/{sessionId}/reschedule',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid session state for reschedule`,
                404: `Session not found`,
            },
        });
    }
    /**
     * Decline a pending reschedule request
     * Client declines a pending reschedule request for a session. The request status is updated to declined and the current scheduled time remains unchanged.
     * @param sessionId Session UUID
     * @returns ClientRescheduleSessionApiResponse Reschedule request declined successfully
     * @throws ApiError
     */
    public static clientSessionsControllerDeclineRescheduleSessionV1(
        sessionId: string,
    ): CancelablePromise<ClientRescheduleSessionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/sessions/{sessionId}/reschedule/decline',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `No pending reschedule request or invalid session state`,
                404: `Session not found`,
            },
        });
    }
    /**
     * Accept or reject attendance
     * Client accepts or rejects attendance marked by the expert. Rejecting creates a dispute for admin review.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns ClientRespondAttendanceApiResponse Attendance response recorded successfully
     * @throws ApiError
     */
    public static clientSessionsControllerRespondToAttendanceV1(
        sessionId: string,
        requestBody: ClientRespondAttendanceDto,
    ): CancelablePromise<ClientRespondAttendanceApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/sessions/{sessionId}/attendance',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid attendance state`,
                404: `Session not found`,
            },
        });
    }
}
